import asPage from "components/core/as-page";
import ErrorPage from "components/core/error-page";

export default asPage(ErrorPage);
